import axios from "axios";
import { decrypt } from "../utils/functions";

export const baseUrl = decrypt(process.env.REACT_APP_BASE_URL_CLIENT);

// export let baseUrl = "https://certage.0009.co/api/";

const api = async (path, params, method) => {
  // let token = JSON.parse(localStorage.getItem("token"));
  // console.log(token, tok, "tokennnnnnnnnnnnnn");

  // 🚫 Prevent API call if token is null or undefined
  // if (!token) {
  //   console.warn("No token found. API call aborted.");
  //   return {
  //     status: 401,
  //     data: { message: "Unauthorized: No token provided." },
  //   };
  // }

  let options = {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer`,
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };

  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
